export default __webpack_public_path__ + "static/media/mpProfile.c719e837.jpeg";